import React, { useState } from 'react';

const TIP_BOJA = {
  react_crash:   { bg: '#2a0a0a', border: '#e94560', tekst: '#e94560', label: '💥 React crash' },
  js_greska:     { bg: '#2a0a0a', border: '#e94560', tekst: '#e94560', label: '🔴 JS greška' },
  promise_greska:{ bg: '#2a1000', border: '#ff6b35', tekst: '#ff6b35', label: '🟠 Promise greška' },
  firebase:      { bg: '#1a1a00', border: '#ffc107', tekst: '#ffc107', label: '🟡 Firebase' },
  greska:        { bg: '#2a0a0a', border: '#e94560', tekst: '#e94560', label: '🔴 Greška' },
  info:          { bg: '#0a1a0a', border: '#2ed573', tekst: '#2ed573', label: '🟢 Info' },
};

function Logi({ logi, obrisiLog, obrisiSveLoge }) {
  const [filter, setFilter] = useState('sve');
  const [otvoren, setOtvoren] = useState(null);
  const [pretraga, setPretraga] = useState('');

  const tipovi = ['sve', 'react_crash', 'js_greska', 'promise_greska', 'firebase', 'greska'];

  const filtrirani = [...logi]
    .filter(l => filter === 'sve' || l.tip === filter)
    .filter(l => !pretraga || l.poruka?.toLowerCase().includes(pretraga.toLowerCase()) || l.strana?.toLowerCase().includes(pretraga.toLowerCase()))
    .sort((a, b) => (b.timestamp || '').localeCompare(a.timestamp || ''));

  const formatirajVrijeme = (ts) => {
    if (!ts) return '?';
    const d = new Date(ts);
    return d.toLocaleDateString('bs-BA') + ' ' + d.toLocaleTimeString('bs-BA');
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '10px' }}>
        <div className="page-title" style={{ margin: 0 }}>🪲 Logi grešaka</div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <span style={{ fontSize: '13px', color: '#666688' }}>{logi.length} zapisa</span>
          {logi.length > 0 && (
            <button
              onClick={() => { if (window.confirm('Obrisati sve loge?')) obrisiSveLoge(); }}
              style={{ padding: '6px 14px', background: 'rgba(233,69,96,0.15)', color: '#e94560', border: '1px solid rgba(233,69,96,0.3)', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
              🗑️ Obriši sve
            </button>
          )}
        </div>
      </div>

      <div style={{ background: '#12122a', borderRadius: '10px', padding: '16px', marginBottom: '16px', border: '1px solid #2a2a4a' }}>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input
            type="text"
            placeholder="Pretraga..."
            value={pretraga}
            onChange={e => setPretraga(e.target.value)}
            style={{ padding: '7px 12px', background: '#16162a', color: '#fff', border: '1px solid #2a2a4a', borderRadius: '6px', fontSize: '13px', minWidth: '200px' }}
          />
          <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {tipovi.map(t => (
              <button key={t}
                onClick={() => setFilter(t)}
                style={{
                  padding: '6px 14px', fontSize: '12px', borderRadius: '6px', cursor: 'pointer',
                  background: filter === t ? '#e94560' : '#16162a',
                  color: filter === t ? '#fff' : '#888899',
                  border: '1px solid ' + (filter === t ? '#e94560' : '#2a2a4a'),
                }}>
                {t === 'sve' ? 'Sve' : (TIP_BOJA[t]?.label || t)}
                {t !== 'sve' && (
                  <span style={{ marginLeft: '6px', background: 'rgba(255,255,255,0.15)', borderRadius: '10px', padding: '1px 6px', fontSize: '11px' }}>
                    {logi.filter(l => l.tip === t).length}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>

      {filtrirani.length === 0 ? (
        <div className="card empty-state">
          <div className="icon">✅</div>
          <p>{logi.length === 0 ? 'Nema zabilježenih grešaka' : 'Nema rezultata za ovaj filter'}</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {filtrirani.map(log => {
            const stil = TIP_BOJA[log.tip] || TIP_BOJA.greska;
            const jeOtvoren = otvoren === log.id;
            return (
              <div key={log.id} style={{
                background: stil.bg,
                border: '1px solid ' + stil.border,
                borderRadius: '8px',
                padding: '12px 16px',
                cursor: 'pointer',
              }}
                onClick={() => setOtvoren(jeOtvoren ? null : log.id)}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap', marginBottom: '4px' }}>
                      <span style={{ fontSize: '12px', color: stil.tekst, fontWeight: '600' }}>{stil.label}</span>
                      <span style={{ fontSize: '11px', color: '#666688' }}>📍 {log.strana}</span>
                      <span style={{ fontSize: '11px', color: '#666688' }}>👤 {log.korisnik}</span>
                    </div>
                    <div style={{ fontSize: '13px', color: '#d0d0d0', fontFamily: 'monospace', wordBreak: 'break-word' }}>
                      {log.poruka}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '6px', flexShrink: 0 }}>
                    <div style={{ fontSize: '11px', color: '#666688', whiteSpace: 'nowrap' }}>
                      {formatirajVrijeme(log.timestamp)}
                    </div>
                    <div style={{ display: 'flex', gap: '6px' }}>
                      <span style={{ fontSize: '11px', color: '#666688' }}>{jeOtvoren ? '▲' : '▼'} detalji</span>
                      <button
                        onClick={e => { e.stopPropagation(); obrisiLog(log.id); }}
                        style={{ fontSize: '11px', padding: '2px 8px', background: 'rgba(233,69,96,0.2)', color: '#e94560', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
                        ✕
                      </button>
                    </div>
                  </div>
                </div>

                {jeOtvoren && (
                  <div style={{ marginTop: '12px', borderTop: '1px solid ' + stil.border, paddingTop: '12px' }}>
                    {log.url && (
                      <div style={{ fontSize: '11px', color: '#666688', marginBottom: '8px' }}>
                        🔗 {log.url}
                      </div>
                    )}
                    {log.stack && (
                      <pre style={{
                        fontSize: '11px', color: '#888899', background: '#0a0a14',
                        borderRadius: '6px', padding: '12px', overflow: 'auto',
                        maxHeight: '300px', margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all',
                      }}>
                        {log.stack}
                      </pre>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default Logi;
